var map = {
	"./10Clubs.jpg": 6419,
	"./10Diamonds.jpg": 4452,
	"./10Hearts.jpg": 1125,
	"./10Spades.jpg": 6856,
	"./2Clubs.jpg": 9443,
	"./2Diamonds.jpg": 1542,
	"./2Hearts.jpg": 9583,
	"./2Spades.jpg": 7829,
	"./3Clubs.jpg": 8563,
	"./3Diamonds.jpg": 935,
	"./3Hearts.jpg": 4149,
	"./3Spades.jpg": 8670,
	"./4Clubs.jpg": 4839,
	"./4Diamonds.jpg": 2531,
	"./4Hearts.jpg": 8359,
	"./4Spades.jpg": 539,
	"./5Clubs.jpg": 8549,
	"./5Diamonds.jpg": 5889,
	"./5Hearts.jpg": 1399,
	"./5Spades.jpg": 3224,
	"./6Clubs.jpg": 5506,
	"./6Diamonds.jpg": 9535,
	"./6Hearts.jpg": 75,
	"./6Spades.jpg": 9113,
	"./7Clubs.jpg": 487,
	"./7Diamonds.jpg": 6653,
	"./7Hearts.jpg": 752,
	"./7Spades.jpg": 5240,
	"./8Clubs.jpg": 9438,
	"./8Diamonds.jpg": 9394,
	"./8Hearts.jpg": 710,
	"./8Spades.jpg": 6343,
	"./9Clubs.jpg": 6884,
	"./9Diamonds.jpg": 4394,
	"./9Hearts.jpg": 3716,
	"./9Spades.jpg": 8786,
	"./AceClubs.jpg": 3356,
	"./AceDiamonds.jpg": 9100,
	"./AceHearts.jpg": 7422,
	"./AceSpades.jpg": 3457,
	"./JackClubs.jpg": 4485,
	"./JackDiamonds.jpg": 3745,
	"./JackHearts.jpg": 7743,
	"./JackSpades.jpg": 2713,
	"./KingClubs.jpg": 5182,
	"./KingDiamonds.jpg": 7402,
	"./KingHearts.jpg": 6568,
	"./KingSpades.jpg": 4576,
	"./QueenClubs.jpg": 7679,
	"./QueenDiamonds.jpg": 2797,
	"./QueenHearts.jpg": 7461,
	"./QueenSpades.jpg": 857,
	"./back.jpg": 9105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4870;